import ClientDetails from './container/index';

export default ClientDetails;



// WEBPACK FOOTER //
// ./src/views/ClientDetails/index.js